<script setup lang="ts">
import { Icon } from '@iconify/vue2'
import { computed } from 'vue'

const { search, registryName } = defineProps<{
	search?: string
	registryName: string
}>()

const emit = defineEmits<{
	(event: 'clear'): void
}>()

const title = computed(() =>
	search ? `Nenhum resultado encontrado para “${search}”` : 'Nenhum registro encontrado',
)

const subtitle = computed(() =>
	search
		? `Tente pesquisar outros termos para obter melhores resultados`
		: `Para começar, clique em “Cadastrar” para criar ${registryName || ''}`,
)

const icon = computed(() =>
	search ? 'streamline:magnifying-glass-solid' : 'fa6-solid:folder-open',
)
</script>

<template>
	<div class="flex justify-center items-center w-full flex-col gap-2 p-16">
		<Icon
			:icon="icon"
			class="text-4xl text-gray-dark"
		/>
		<p class="text-default">{{ title }}</p>
		<p class="text-default">{{ subtitle }}</p>
		<a
			v-if="search"
			@click="emit('clear')"
			class="text-default-underline"
			>Limpar pesquisa
		</a>
	</div>
</template>
